export default "__VITE_ASSET__DTPuJ0OD__"